import clsx from "clsx";
import classes from "./Word.module.scss";

export const Word = (props) => {
    const { word, styles={}, place, mode, animationStatus } = props;

    if (!word) return null;

    return (
        <div 
            data-word
            className={clsx(
                classes.word,
                classes[place],
                classes[mode],
                styles.ghost && classes.ghost,
                styles.correct && classes.correct,
                styles.wrong && classes.wrong,
                styles.dragging && classes.dragging
            )}
            key={word.id}
            data-animation-status={animationStatus}
        >
            <span>{word.data}</span>
        </div>
    );
}